export function getMockEditorWorkspaceUrl(paperId: number): string {
  const baseOrigin =
    typeof window !== 'undefined' ? window.location.origin : 'http://localhost:8191'
  return new URL(`/_mf/mock/editor/papers/${paperId}`, `${baseOrigin}/`).toString()
}
